import styled from 'styled-components';

import { DropdownContainerProps } from './types';

import { OptionsContainer } from 'features/common/components/Filters/components/DesktopFilters/DesktopFilters.styles';
import { FilterSearch } from 'features/common/components/Filters/components/MobileFilter/MobileFilter.styles';
import { Button } from 'features/common/components/Button';

export { Error } from 'features/common/components/Form/Form.styles';
export { OptionsContainer } from 'features/common/components/Filters/components/DesktopFilters/DesktopFilters.styles';

export const DropdownWrap = styled.div<DropdownContainerProps & { isPunchup?: boolean }>`
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)};
	border: ${({ isPunchup }) => (isPunchup ? '1px solid #e5e5e5' : '0.5px solid transparent')};
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	height: 40px;
	width: 100%;
	padding: 5px 15px;
	border-radius: 2px;
	font-family: ${({ theme }) => theme.fonts.primary};
	font-weight: 400;
	font-size: 16px;
	box-sizing: border-box;
	position: relative;

	&:focus {
		outline: ${({ hasError }) => hasError && '0'};
		border: ${({ hasError, theme }) =>
			hasError ? `0.5px solid ${theme.colors.red}` : `0.5px solid ${theme.colors.lightGrey4}`};
	}
`;

export const InputDisplay = styled.div<{ isPunchup?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: relative;
	height: 25px;
	top: 2px;
	left: 4px;
	cursor: pointer;

	span {
		color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	}
`;

export const Container = styled(OptionsContainer)<{ isPunchup?: boolean }>`
	position: absolute;
	top: calc(100% + 6px);
	left: 0;
	width: 100%;
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)};
	border: ${({ isPunchup }) => (isPunchup ? '1px solid #e5e5e5' : 'none')};
	z-index: 10;
`;

export const Search = styled(FilterSearch)<{ isPunchup?: boolean }>`
	max-width: unset;
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)} !important;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)} !important;
	border: ${({ theme, isPunchup }) => (isPunchup ? '1px solid #e5e5e5' : `1px solid ${theme.colors.grey6}`)} !important;
`;

export const SearchContainer = styled.div<{ isPunchup?: boolean }>`
	padding: 12px;
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)};
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
`;

export const ButtonContainer = styled.div<{ isPunchup?: boolean }>`
	gap: 16px;
	display: flex;
	flex-direction: column;
	padding: 16px;
	box-sizing: border-box;
	justify-content: center;
`;

export const CustomButton = styled(Button)<{ isPunchup?: boolean }>`
	padding: 7px 16px;
	margin: 0;
	font-size: 14px;
	font-weight: 600;
	width: 100%;

	${({ isPunchup, category }) =>
		isPunchup &&
		category === 'outlined' &&
		`
		border: 1px solid #e5e5e5;
		color: #333;
		background: white;

		&:hover:not(:disabled) {
			background: #f5f5f5;
		}
	`}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const FilterButton = styled(Button)<{ isPunchup?: boolean }>`
	padding: 7px 0;
	margin: 0;
	font-size: 16px;
	font-weight: 600;
	flex: 0 50%;

	${({ isPunchup, category }) =>
		isPunchup &&
		category === 'outlined' &&
		`
		border: 1px solid #e5e5e5;
		color: #333;
		background: white;

		&:hover:not(:disabled) {
			background: #f5f5f5;
		}
	`}

	${({ isPunchup, category }) =>
		isPunchup &&
		category === 'primary' &&
		`
		background: #FE5E25;
		color: white;
		border: 1px solid #FE5E25;

		&:hover:not(:disabled) {
			background: #E54515;
			border-color: #E54515;
		}
	`}

	&:disabled {
		display: none;
	}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		font-size: 14px;
	}
`;
